export enum LevelType {
  PLACEMENT_FOLDER = 'placement_folder',
  PRICING_ITEM = 'pricing_item',
}

export enum PlacementFolderOrdering {
  NAME_ASC = 'name_asc',
  NAME_DESC = 'name_desc',
  USER_DEFINED_ID_ASC = 'user_defined_id_asc',
  USER_DEFINED_ID_DESC = 'user_defined_id_desc',
  DATE_FROM_ASC = 'date_from_asc',
  DATE_FROM_DESC = 'date_from_desc',
  PRICE_TYPE_ASC = 'price_type_asc',
  PRICE_TYPE_DESC = 'price_type_desc',
  PRICE_ASC = 'price_asc',
  PRICE_DESC = 'price_desc',
  CREATED_AT_DESC = 'created_at_desc',
}
